import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import CreationFormWrapper from "../../actprep-ui/components/CreationFormWrapper";
import { usePost } from "../../actprep-ui/hooks/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import ProgramWeekForm from "../ProgramWeekForm";

export default function AddWeekToProgramForm({
  open,
  setOpen,
  program,
  onProgramWeekAdded,
}) {
  const [programWeek, setProgramWeek] = useState(null);
  const [error, setError] = useState(null);
  const addProgramWeekToProgramMutation = usePost(
    apiUrls.admin.programWeekToProgram()
  );
  const onSubmit = async () => {
    const payload = {
      program_uuid: program?.uuid,
      program_week_uuid: programWeek.uuid,
    };
    const { data } = await addProgramWeekToProgramMutation.mutateAsync(payload);
    if (!data.success) {
      setError(data.reason);
      return;
    }
    setOpen(false);
    onProgramWeekAdded();
  };
  const handleClose = () => setOpen(false);
  useEffect(() => {
    if (open) {
      setProgramWeek(null);
    }
  }, [open]);

  return (
    <>
      <CreationFormWrapper
        open={open}
        onClose={handleClose}
        onSubmit={onSubmit}
        error={error}
        title={`Add a week to '${program?.label}'`}
      >
        <Grid container gap={3} marginTop={1}>
          <Grid size={12}>
            <ModelAutoComplete
              modelName={"ProgramWeek"}
              label={"Program Week"}
              value={programWeek}
              setValue={setProgramWeek}
              allowCreation
              CreationForm={(props) => <ProgramWeekForm {...props} />}
            />
          </Grid>
        </Grid>
      </CreationFormWrapper>
    </>
  );
}
